import React from 'react';
import { Spin } from 'antd';
import { SpinProps } from 'antd/lib/spin';

const ProSpin: React.FC<SpinProps &
React.RefAttributes<HTMLElement>> = (props) => {
  const { children, ...resProps } = props;
  return (
    <Spin {...resProps}>
      {children}
    </Spin>
  );
};

ProSpin.defaultProps = {
  className: 'page-full flex-center-center',
};

export default ProSpin;
